import React from 'react';
import PropTypes from 'prop-types';

const STYLES = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

const PAGE_NOT_FOUND = {
  margin: '0',
  padding: '0',
  fontWeight: 'bold',
  whiteSpace: 'nowrap',
  animation: 'bounce 650ms ease-outerHeight',
  fontSize: '4rem',
};

export class ErrorBoundary extends React.Component {

  static propTypes = {
    errorLog: PropTypes.func.isRequired,
    appName: PropTypes.string.isRequired,
    customStateData: PropTypes.object,
  };

  static getDerivedStateFromError(error) { // eslint-disable-line
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  state = {
    hasError: false,
  };

  /*
  * @param object error
  * @param object info
  * 
  * This logs application errors to the UESPLog database into the SvcDataLog table
  */
  componentDidCatch(error, info) {
    const { customStateData, errorLog, appName } = this.props;

    const errorInfo = error ? error : info;
    const stackTrace = error.stack;
    const stateData = JSON.stringify({
      app: appName,
      type: errorInfo.name,
      message: errorInfo.message,
      url: window.location.href,
      browserAgent: window.navigator.userAgent,
      ...customStateData,
    });

    errorLog({ stackTrace, stateData });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={STYLES}>
          <div style={{ textAlign: 'center' }}>
            <p>Oops! Something didn&#39;t go as planned.</p>
          </div>
          <div style={PAGE_NOT_FOUND}>
            {'¯\\_(ツ)_/¯'}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;